var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar-area",attrs:{"data-image-object-fit-compat-ie":""}},[_c('img',{attrs:{"src":"/avatar.png","alt":"头像"}})])}]

export { render, staticRenderFns }